import BlankInput from './blank-input.vue';
export default BlankInput;